import { render, staticRenderFns } from "./UnpinIcon.vue?vue&type=template&id=3141d9d0&scoped=true"
import script from "./UnpinIcon.vue?vue&type=script&lang=js"
export * from "./UnpinIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3141d9d0",
  null
  
)

export default component.exports